export default __webpack_public_path__ + "static/media/27.6e221366.png";